'use client';

import Block from '@/components/elements/Block';
import Container from '@/components/elements/Container';
import { useSiteSettings } from '@/contexts/SiteSettingsContext';
import { cmsColorClass } from '@/utils/cmsColorClass';
import { jsonToHtml } from '@contentstack/json-rte-serializer';

const CampaignBannerClient = ({ position }) => {
  const { campaign } = useSiteSettings();

  if (!campaign?.campaign_banner) return null;

  const { heading, content, settings } = campaign.campaign_banner;
  const contentHtml = jsonToHtml(content);

  // BL-743: the heading and the body both hardcoded `text-white`, so the CMS
  // text colour was never wired up at all. It lands on the section rather than
  // on each child so the two stay in step, and it falls back to white for a
  // campaign that has no colour set — without that, it would flip to `Block`'s
  // `text-black` default on a dark banner.
  const textColor = cmsColorClass(settings?.text_color?.color_selector, 'text-white');
  // The colour comes from settings.background_color, the field every other
  // block already uses, rather than the banner's own "Banner Color" — one place
  // in the CMS drives the banner and the utility bar together.
  const bannerColor = cmsColorClass(settings?.background_color?.color_selector);

  // Those two belong to the band, not to the block around it: `Block` would
  // paint the full-width wrapper with the same background and the inset band
  // would disappear into a slab. The wrapper keeps its own defaults, the
  // padding settings pass through untouched.
  const blockSettings = { ...settings, background_color: null, text_color: null };

  return (
    <Block name="campaign_banner" settings={blockSettings} position={position}>
      <Container>
        <section className={`text-center ${bannerColor} ${textColor} py-10 px-4`}>
          <h2 className="font-cormorant text-5xl font-light mb-4">{heading}</h2>
          <div
            className="text-base tracking-wide"
            data-rte-content
            dangerouslySetInnerHTML={{ __html: contentHtml }}
          />
        </section>
      </Container>
    </Block>
  );
};

export default CampaignBannerClient;
